import NoImage from "../images/no-image.png";
import ShowIcon from "../Components/ShowIcon";
import {
  Form,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { LuBell, LuSearch, LuBellDot, LuMail } from "react-icons/lu";
import { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { DataContext } from "../context/DataContext";
import { RxCross2 } from "react-icons/rx";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { RiLockPasswordLine } from "react-icons/ri";
import PwDetailsModal from "../Components/Modal/PwDetailsModal";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
function HeaderComponent(props) {
  const history = useHistory();

  const [searchBox, setSearchBox] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notidropdownOpen, setNotiDropdownOpen] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [pwDetailsModal, setPwDetailsMoveModal] = useState(false);
  const [pwDetails, setpwDetails] = useState({});

  const { adminViewUser, setAdminViewUser, setLoader } =
    useContext(DataContext);
  const toggleDropdown = () =>
    setDropdownOpen((prevState) => !prevState);
  const notiToggleDropdown = async () => {
    setNotiDropdownOpen((prevState) => !prevState);
    await ApiCallGateway.notification.readNotifications();
    notificationRefetch();
  };

  const pwDetailstoggle = () =>
    setPwDetailsMoveModal(!pwDetailsModal);
  const userData = JSON.parse(localStorage.getItem("loggedInUser"));

  const {
    isLoading,
    error,
    data: searchList,
    refetch,
  } = useQuery({
    queryKey: ["search"],
    queryFn: async () => {
      const res = await ApiCallGateway.password.searchPassword(
        searchString
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });
  const { data: notificationList, refetch: notificationRefetch } =
    useQuery({
      queryKey: ["notification"],
      queryFn: async () => {
        const res =
          await ApiCallGateway.notification.getAllNotifications();
        if (res?.status === 200) {
          return res?.data;
        } else {
          return [];
        }
      },
    });
  useEffect(() => {
    refetch();
  }, [searchString]);

  const getPasswordDetails = async (pId) => {
    setLoader(true);
    const res = await ApiCallGateway.password.getAPasswordDetails(
      pId
    );
    console.log(res);
    setpwDetails(res?.data[0]);
    pwDetailstoggle();
    setLoader(false);
  };
  const logout = async () => {
    const willDelete = await swal({
      title: "Logout",
      text: "Are you sure?",
      icon: "warning",
      dangerMode: true,
      buttons: "confirm",
    });

    if (willDelete) {
      Cookies.remove("access_token");
      window.location.href = "/login";
      localStorage.removeItem("loggedInUser");
    }
  };

  return (
    <div className="header-container">
      <div className="header">
        <div className="header-left">
          <h1>{props?.title}</h1>
          {/* <img
            src={ArrowDown}
            alt=""
            style={{
              width: "24px",
              height: "24px",
              marginLeft: "5px",
            }}
          /> */}
        </div>

        <div className="header-right">
          <div style={{ display: "flex" }}>
            {searchBox ? (
              <Form className="formWrap">
                <div className="choseMember">
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                    // onBlur={() => setSearchBox(false)}
                  >
                    <DropdownToggle caret>
                      <div className="formElmWrap">
                        <Input
                          id="search"
                          name="search"
                          placeholder="Enter Search String"
                          type="text"
                          autoComplete="off"
                          // autoFocus
                          onChange={(e) =>
                            setSearchString(e.target.value)
                          }
                        />
                        <span
                          className="formIcon plus"
                          // onClick={() => setSearchBox(true)}
                        >
                          <LuSearch />
                        </span>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      {searchList &&
                        searchList?.map((item) => {
                          return (
                            <DropdownItem
                              key={item?.passwordId}
                              onClick={() =>
                                getPasswordDetails(item?.passwordId)
                              }
                            >
                              <RiLockPasswordLine size={30} />
                              {item?.identifier}
                            </DropdownItem>
                          );
                        })}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </Form>
            ) : (
              <ShowIcon
                iconName={
                  <LuSearch
                    className="iconstyle-svg search-icon "
                    style={{
                      height: "30px",
                      width: "30px",
                      // color: "#E63838",
                    }}
                  />
                }
                tooltip_id="Search"
                tooltip_content="Search"
                onIconClick={() => setSearchBox(true)}
                className="header-right-icon"
              />
            )}
            <Form className="formWrap">
              <div className="choseMember">
                <Dropdown
                  isOpen={notidropdownOpen}
                  toggle={notiToggleDropdown}
                >
                  <DropdownToggle caret>
                    <ShowIcon
                      iconName={
                        notificationList?.length > 0 &&
                        !notificationList[0]?.isRead ? (
                          <div className="bellWrap">
                            <LuBell
                              className="iconstyle-svg"
                              style={{
                                height: "30px",
                                width: "30px",
                              }}
                            />
                            <span className="bullet"></span>
                          </div>
                        ) : (
                          <LuBell
                            className="iconstyle-svg"
                            style={{ height: "30px", width: "30px" }}
                          />
                        )
                      }
                      tooltip_id="notification"
                      tooltip_content="Notifications"
                      onIconClick={() => console.log("Bell click")}
                      className="header-right-icon"
                    />
                  </DropdownToggle>
                  <DropdownMenu style={{ width: 320 }}>
                    {notificationList &&
                      notificationList?.map((item) => {
                        return (
                          <DropdownItem
                            key={item?._id}
                            onClick={() => {
                              if (item?.type === "password") {
                                getPasswordDetails(item?.passwordId);
                              }
                              if (
                                item?.type === "folder" &&
                                item?.folderId
                              ) {
                                history.push(
                                  `/env_subfolder/${item?.folderId}`
                                );
                              }
                              if (
                                item?.type === "env" &&
                                item?.envId
                              ) {
                                history.push(
                                  `/env_passwords/${item?.envId}`
                                );
                              }
                            }}
                          >
                            <img
                              className="memberIcon "
                              src={item?.profilePhoto || NoImage}
                              alt="user"
                              referrerPolicy="no-referrer"
                            />
                            <span>
                              {item?.name + "," + item?.content}
                            </span>
                          </DropdownItem>
                        );
                      })}
                  </DropdownMenu>
                </Dropdown>
              </div>
            </Form>

            {/* <Notification /> */}
            {/* <ShowIcon
              iconName={
                true ? (
                  <div className="bellWrap">
                    <LuBell
                      className="iconstyle-svg"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <span className="bullet"></span>
                  </div>
                ) : (
                  <LuBell
                    className="iconstyle-svg"
                    style={{ height: "30px", width: "30px" }}
                  />
                )
              }
              tooltip_id="notification"
              tooltip_content="Notifications"
              onIconClick={() => console.log("Bell click")}
              className="header-right-icon"
            /> */}
          </div>

          <div className="header-user" onClick={() => logout()}>
            <img
              className="memberIcon "
              src={userData?.profilePhoto || NoImage}
              alt="user"
              referrerPolicy="no-referrer"
              style={{ height: 45, width: 45 }}
            />
            <div className="header-user-data">
              <h6>{userData?.name}</h6>
              <p>{"Logout"}</p>
            </div>
          </div>
        </div>
      </div>
      {adminViewUser?.name ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              backgroundColor: "black",
              height: "90px",
              borderTopLeftRadius: 5,
              borderBottomLeftRadius: 5,
              width: "25%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h4
              style={{
                color: "white",
                margin: 0,
              }}
            >
              You are currently viewing :
            </h4>
          </div>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              height: "90px",
              backgroundColor: "#222222",
              position: "relative",
              width: "75%",
              borderTopRightRadius: 5,
              borderBottomRightRadius: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "50px",
                gap: "50px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <img
                  className="userImg memberIcon "
                  src={adminViewUser?.profilePhoto || NoImage}
                  alt="user"
                  referrerPolicy="no-referrer"
                  style={{ height: 50, width: 50 }}
                />
                <h6 style={{ color: "white", margin: 0 }}>
                  {adminViewUser?.name}
                </h6>
              </div>
              <div>
                <LuMail size={20} color="#FCEA4C" />
                <span
                  style={{
                    color: "#6E7898",
                    margin: 0,
                    paddingLeft: "3px",
                  }}
                >
                  {adminViewUser?.email}
                </span>
              </div>
            </div>
            {/* <div style={{ alignItems: "center" }}> */}
            <RxCross2
              color="#4D4D4D"
              className="editBtn"
              size={25}
              style={{ alignSelf: "center", margin: "10px" }}
              cursor={"pointer"}
              onClick={() => setAdminViewUser({})}
            />
            {/* </div> */}
          </div>
        </div>
      ) : null}
      <PwDetailsModal
        pwDetailsModal={pwDetailsModal}
        pwDetailsModaltoggle={pwDetailstoggle}
        details={pwDetails}
      />
    </div>
    // <div className="header">
    //   <div className="logo">
    //     <Link to="/">
    //       <div className="circle"></div>
    //       <span style={{ fontSize: "30px" }}>VAULT</span>
    //     </Link>
    //   </div>
    //   <img
    //     src={profilePic || NoImage}
    //     alt=""
    //     className="rounded-circle"
    //     width={42}
    //     height={42}
    //     style={{ cursor: "pointer" }}
    //   />
    // </div>
  );
}

export default HeaderComponent;
